import { render, staticRenderFns } from "./ActionFile.vue?vue&type=template&id=5e790231&scoped=true&"
import script from "./ActionFile.vue?vue&type=script&lang=js&"
export * from "./ActionFile.vue?vue&type=script&lang=js&"
import style0 from "./ActionFile.vue?vue&type=style&index=0&id=5e790231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e790231",
  null
  
)

export default component.exports